import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
  defaultWebsocketParsingOptions,
  defaultWebsocketTimeouts,
} from './base';
import type { VeloCloudApiSettingsDefaults } from './types';

// the official doc: https://developer.vmware.com/apis/1748/#api

export const veloCloudDefaults: VeloCloudApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  ...defaultWebsocketParsingOptions,
  ...defaultWebsocketTimeouts,
  // Session cookies typically expire after a period of 24 hours (though lifetimes are configurable and may vary across VCO deployments).
  defaultSessionTimeoutSec: 24 * 60 * 60, // 24 hours
  // When an API client is rate limited, it incurs a "penalty" whereby the server refuses to process new requests on its behalf for a brief period of time (5 seconds, by default).
  tooManyRequestsWaitTimeMs: 5000,
  // Leaky-bucket limits prevent bursty client activity by limiting the number of requests processed by the server on behalf of a particular client or tenant within a short time period (5 seconds, by default)
  refillRateIntervalMs: 5000,
  maxCapacity: 1000,
  refillRate: 1000,
  maxConcurrentRequests: 1000,
  veloCloudWsCommandMaxAttempts: 3,
  veloCloudWsCommandRetryDelayMs: 1000,
};
